var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFounderRelations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 22.5,
    fill: "white",
    stroke: "#FFDF00",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8873_2577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 18C17 19.0609 17.4214 20.0783 18.1716 20.8284C18.9217 21.5786 19.9391 22 21 22C22.0609 22 23.0783 21.5786 23.8284 20.8284C24.5786 20.0783 25 19.0609 25 18C25 16.9391 24.5786 15.9217 23.8284 15.1716C23.0783 14.4214 22.0609 14 21 14C19.9391 14 18.9217 14.4214 18.1716 15.1716C17.4214 15.9217 17 16.9391 17 18Z",
    stroke: "#FFDF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 32V30C15 28.9391 15.4214 27.9217 16.1716 27.1716C16.9217 26.4214 17.9391 26 19 26H23C24.0609 26 25.0783 26.4214 25.8284 27.1716C26.5786 27.9217 27 28.9391 27 30V32",
    stroke: "#FFDF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 14.1299C28.8604 14.3502 29.623 14.8506 30.1676 15.5522C30.7122 16.2538 31.0078 17.1167 31.0078 18.0049C31.0078 18.8931 30.7122 19.756 30.1676 20.4576C29.623 21.1592 28.8604 21.6596 28 21.8799",
    stroke: "#FFDF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 31.9999V29.9999C32.9949 29.1171 32.6979 28.2607 32.1553 27.5643C31.6126 26.8679 30.8548 26.3706 30 26.1499",
    stroke: "#FFDF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8873_2577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounderRelations);
export default __webpack_public_path__ + "static/media/founder-relations.3f6084acfc7b41cbfbd6a05906134fb9.svg";
export { ForwardRef as ReactComponent };